import React from 'react';
import ToggleGroup from '../../../../../components/button/ToggleGroup';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { isSkillGroupBy, SkillGroupBy } from '../common/skillGrouping';

type Props = {
  value: SkillGroupBy;
  onChange: (value: SkillGroupBy) => void;
  className?: string;
};

export const RadarGroupingToggle: React.FC<React.PropsWithChildren<Props>> = ({
  value,
  onChange,
  className,
}) => {
  const t = useNamespacedTranslation('skills.grouping');
  return (
    <div className="d-flex align-items-center gap-2">
      <span className="small text-dark text-nowrap">{t('label')}</span>
      <ToggleGroup
        variant="secondary"
        containerClassName={className}
        value={value}
        onChange={(v) => onChange(isSkillGroupBy(v) ? v : 'skill')}
        buttons={[
          { name: 'skill', title: t('bySkill') },
          { name: 'category', title: t('byCategory') },
          { name: 'branch', title: t('byBranch') },
        ]}
      />
    </div>
  );
};
